













































import {
  computed, defineComponent, PropType, ref, Ref,
} from 'vue';

import api from '@/api';

export default defineComponent({
  name: 'NetworkCreateForm',
  props: {
    edgeTables: {
      type: Array as PropType<string[]>,
      required: true,
    },

    workspace: {
      type: String as PropType<string>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const networkCreationErrors: Ref<string[]> = ref([]);
    const networkEdgeTable: Ref<string | null> = ref(null);
    const newNetwork = ref('');
    const loading = ref(false);

    const networkCreateDisabled = computed(() => !networkEdgeTable.value || !newNetwork.value);

    function clear() {
      networkEdgeTable.value = null;
      newNetwork.value = '';
      loading.value = false;
    }

    async function createNetwork() {
      if (networkEdgeTable.value === null) {
        throw new Error('this.networkEdgeTable must not be null');
      }

      try {
        loading.value = true;
        await api.createNetwork(props.workspace, newNetwork.value, {
          edgeTable: networkEdgeTable.value,
        });
        networkCreationErrors.value = [];
        clear();
        emit('success');
      } catch (error) {
        const message = `Network "${newNetwork.value}" already exists.`;
        networkCreationErrors.value = [message];
      }
    }

    return {
      networkCreationErrors,
      networkEdgeTable,
      newNetwork,
      loading,
      networkCreateDisabled,
      createNetwork,
    };
  },
});
